import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import {Container} from "react-bootstrap";
import { history } from "./_helpers";
import Routes from "./routes/routes";
import Header from "./components/Common/headerComponent";
import './asset/css/App.scss';
import SosBreakingComponent from "./components/SosBreaking/sosBreakingComponent";

export default function App() {
    return (
       <Router history={history}>
           <Container fluid >
               <Header />
               <Routes />
               <SosBreakingComponent />
           </Container>
        </Router>
    );
}



